import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistance from "vuex-persist";

import state from './state';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

import auth from '../modules/authentication'
import general from '../modules/general'

Vue.use(Vuex)

const vuexlocal = new VuexPersistance({
  storage: window.localStorage,
  modules: ['auth', 'general']
})

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth,
    general,
  },
  plugins: [vuexlocal.plugin]
})
